import { createFile, deleteFile } from "./fileApi";

export const handlePendingFiles = async ({ pendingAttachments, pendingDeletions, ticketUpdate, queryClient }) => {
  console.log("Handling pending files...");
  console.log("Pending files to upload:", pendingAttachments);
  console.log("Pending files to delete:", pendingDeletions);

  // Upload the pending attachments passed from TicketNoteEditor
  if (pendingAttachments && pendingAttachments.length > 0) {
    try {
      await Promise.all(
        pendingAttachments.map((file) =>
          createFile({
            file,
            entity_type: "ticket_update",
            entity_id: ticketUpdate.id,
          }),
        ),
      );
      // Invalidate attachments cache
      queryClient.invalidateQueries({
        queryKey: ["files", { entity_type: "ticket_update", entity_id: ticketUpdate.id }],
      });
    } catch (error) {
      console.log(error?.message || "File upload failed");
    }
  }

  // Delete the files marked for deletion
  if (pendingDeletions && pendingDeletions.length > 0) {
    try {
      await Promise.all(pendingDeletions.map((fileId) => deleteFile(fileId)));
      // Invalidate files cache
      queryClient.invalidateQueries({
        queryKey: ["files", { entity_type: "ticket_update", entity_id: ticketUpdate.id }],
      });
    } catch (error) {
      console.log(error?.message || "File deletion failed");
    }
  }
};
